var _style, _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgCuratorSymbol(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 261.21 279.83",
    style: {
      enableBackground: "new 0 0 261.21 279.83"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.2;}\r\n\t.st1{fill:#8C46FF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.36,147.12l-37.65-21.73V81.91c0-1.79-0.96-3.45-2.51-4.35h0c-3.35-1.93-7.54,0.48-7.54,4.35l0,49.27 l42.67,24.64c3.35,1.93,7.54-0.48,7.54-4.35l0,0C195.88,149.68,194.92,148.02,193.36,147.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.36,123.92l-17.55-10.13l0-20.27c0-1.79-0.96-3.45-2.51-4.35c-3.35-1.93-7.54,0.48-7.54,4.35l0,26.07 l22.58,13.03c3.35,1.93,7.54-0.48,7.54-4.35l0,0C195.88,126.47,194.92,124.81,193.36,123.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.39,100.73L193.39,100.73c-1.55-0.9-3.47-0.9-5.02,0h0c-1.55,0.9-2.51,2.56-2.51,4.35l0,0 c0,1.79,0.96,3.45,2.51,4.35h0c1.55,0.9,3.47,0.9,5.02,0h0c1.55-0.9,2.51-2.56,2.51-4.35l0,0 C195.91,103.29,194.95,101.63,193.39,100.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.86,155.82l42.67-24.64l0-49.27c0-3.87-4.19-6.28-7.54-4.35l0,0c-1.55,0.9-2.51,2.56-2.51,4.35v43.47 l-37.65,21.74c-1.55,0.9-2.51,2.56-2.51,4.35l0,0C65.32,155.34,69.51,157.75,72.86,155.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.84,123.92c-1.55,0.9-2.51,2.56-2.51,4.35c0,3.87,4.19,6.28,7.54,4.35l22.58-13.03l0-26.07 c0-3.87-4.19-6.28-7.54-4.35c-1.55,0.9-2.51,2.56-2.51,4.35l0,20.27L67.84,123.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.8,109.43L67.8,109.43c1.55,0.9,3.47,0.9,5.02,0h0c1.55-0.9,2.51-2.56,2.51-4.35s-0.96-3.45-2.51-4.35h0 c-1.55-0.9-3.47-0.9-5.02,0c-1.55,0.9-2.51,2.56-2.51,4.35S66.25,108.54,67.8,109.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173.27,181.92l-42.67-24.64l-42.67,24.64c-3.35,1.93-3.35,6.77,0,8.7l0,0c1.55,0.9,3.47,0.9,5.02,0 l37.65-21.74l37.65,21.74c1.55,0.9,3.47,0.9,5.02,0l0,0C176.62,188.69,176.62,183.86,173.27,181.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.17,193.53l-22.58-13.03l-22.58,13.03c-3.35,1.93-3.35,6.77,0,8.7h0c1.55,0.9,3.47,0.9,5.02,0 l17.55-10.13l17.55,10.13c1.55,0.9,3.47,0.9,5.02,0l0,0C156.52,200.29,156.52,195.46,153.17,193.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133.11,205.15c-1.55-0.9-3.47-0.9-5.02,0l0,0c-1.55,0.9-2.51,2.56-2.51,4.35c0,1.79,0.96,3.45,2.51,4.35l0,0 c1.55,0.9,3.47,0.9,5.02,0c1.55-0.9,2.51-2.56,2.51-4.35C135.62,207.7,134.67,206.04,133.11,205.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.54,148.56L115.54,148.56c-1.39-2.4-4.46-3.23-6.86-1.84l-40.83,23.6c-2.4,1.39-3.23,4.46-1.84,6.86l0,0 c1.39,2.4,4.46,3.23,6.86,1.84l40.83-23.6C116.11,154.04,116.93,150.96,115.54,148.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.35,170.32l-40.83-23.6c-2.4-1.39-5.48-0.56-6.86,1.84c-1.39,2.4-0.56,5.48,1.84,6.86l40.83,23.6 c2.4,1.39,5.48,0.56,6.86-1.84S195.75,171.71,193.35,170.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.59,122.48c2.77,0,5.02-2.25,5.02-5.02l0.01-47.13c0-2.77-2.25-5.02-5.02-5.02 c-2.77,0-5.02,2.25-5.02,5.02l-0.01,47.13C125.57,120.23,127.82,122.48,130.59,122.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133.11,135.54L133.11,135.54c-1.55-0.9-3.47-0.9-5.02,0l0,0c-1.55,0.9-2.51,2.56-2.51,4.35v0 c0,1.79,0.96,3.45,2.51,4.35l0,0c1.55,0.9,3.47,0.9,5.02,0l0,0c1.55-0.9,2.51-2.56,2.51-4.35v0 C135.62,138.09,134.67,136.43,133.11,135.54z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuratorSymbol);
export default __webpack_public_path__ + "static/media/Curator_Symbol.89a48423e11e8014f9133613c55647cd.svg";
export { ForwardRef as ReactComponent };